// Shared workflow status constants — keep in sync with the backend orchestrator
// (FWAPI: fieldworker/helpers/workflows.js)

// Workflow definition status (wf_status)
export const WF_STATUS = {
    DRAFT: 0,
    PUBLISHED: 1,
};

// Workflow instance status (wf_instanceStatus)
export const INSTANCE_STATUS = {
    NOT_STARTED: 0,
    IN_PROGRESS: 1,
    COMPLETED: 2,
    PAUSED: 3,
    CLOSED: 4,
    BLOCKED: 5,
};

export const INSTANCE_STATUS_LABELS = {
    [INSTANCE_STATUS.NOT_STARTED]: 'Not Started',
    [INSTANCE_STATUS.IN_PROGRESS]: 'In Progress',
    [INSTANCE_STATUS.COMPLETED]: 'Completed',
    [INSTANCE_STATUS.PAUSED]: 'Paused',
    [INSTANCE_STATUS.CLOSED]: 'Closed',
    [INSTANCE_STATUS.BLOCKED]: 'Blocked',
};

// Edge lifecycle status (edge_status)
export const EDGE_STATUS = {
    COMPLETED: 0,
    ACTIVE: 1,
    BLOCKED: 2,
};

// Instances in these states can no longer be modified
export const READONLY_INSTANCE_STATUSES = [INSTANCE_STATUS.COMPLETED, INSTANCE_STATUS.CLOSED];

// Whether a workflowEdge record is the given edge from the workflow definition. A decision/approval
// node's two branches can share a target, so the source handle ('one' = No/Reject, 'two' = Yes/Approve)
// is what tells them apart. Records written before edge_wf_sourceHandle existed match on source + target.
export const isInstanceOfEdge = (edgeRecord, schemaEdge) =>
    edgeRecord.edge_wf_sourceID === schemaEdge.source &&
    edgeRecord.edge_wf_targetID === schemaEdge.target &&
    (!edgeRecord.edge_wf_sourceHandle || edgeRecord.edge_wf_sourceHandle === schemaEdge.sourceHandle);
